import { c as _c } from "react-compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import useI18nString from '@nike/shop-apis/assets/i18n/dotcom-cart/use-query';
import useFetchCart from '@nike/shop-apis/buy/carts/v2/fetch/use-query';
import useFetchProductContentQueries from '@nike/shop-apis/product-feed-threads/v2/use-queries';
import MessageText from "../message-text";
import useErrorModalStore from "../../store/error-modal/use-store";
export var FALLBACK_STRING_KEY = 'generic.error.message';
export var FALLBACK_PRIMARY_VALUE = 'We had an issue with your request. If you continue experiencing issues, try refreshing the page.';
var ErrorMessageProductInfo = function ErrorMessageProductInfo(t0) {
  var $ = _c(27);
  var crcCode = t0.crcCode;
  var error = useErrorModalStore(_temp);
  var _ref = useFetchCart({
      select: function select(cartData) {
        var field = (error === null || error === void 0 ? void 0 : error.field) || "";
        var match = field.match(/items\/([^/]+)/);
        var cartItemId = match ? match[1] : null;
        var cartItem = null;
        if (cartData !== null && cartData !== void 0 && cartData.items && cartItemId) {
          cartItem = cartData.items.find(function (item) {
            return item.id === cartItemId;
          });
        }
        var cartItemsFromError = (error === null || error === void 0 ? void 0 : error.items) || [];
        var hasItemsRemoved = Boolean(cartItemsFromError.length);
        if (cartItem || hasItemsRemoved) {
          var _cartItem;
          var ids = (_cartItem = cartItem) !== null && _cartItem !== void 0 && _cartItem.productId ? [cartItem.productId] : cartItemsFromError.map(_temp2).filter(Boolean);
          return {
            productIds: ids,
            itemsRemoved: hasItemsRemoved
          };
        }
        return {
          productIds: [],
          itemsRemoved: false
        };
      }
    }).data || {
      productIds: [],
      itemsRemoved: false
    },
    productIds = _ref.productIds,
    itemsRemoved = _ref.itemsRemoved;
  var t1;
  if ($[0] !== productIds) {
    t1 = productIds.map(_temp3);
    $[0] = productIds;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  var productsToFetch = t1;
  var t2;
  if ($[2] !== productsToFetch) {
    t2 = {
      products: productsToFetch
    };
    $[2] = productsToFetch;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  var productQueries = useFetchProductContentQueries(t2);
  var t3;
  if ($[4] === Symbol["for"]("react.memo_cache_sentinel")) {
    t3 = {
      stringKey: "item.removed.error.message",
      primaryValue: "The following items are no longer available and will be removed from your cart: ",
      description: "Message to user indicating unavailable product(s) will be removed from their cart"
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  var removedMessage = useI18nString(t3);
  var t4;
  if ($[5] === Symbol["for"]("react.memo_cache_sentinel")) {
    t4 = {
      stringKey: "item.unavailable.error.message",
      primaryValue: "Some of your items are no longer available. Please remove the following and try again: ",
      description: "Message to user indicating their need to manually remove product(s) from their cart"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  var unavailableMessage = useI18nString(t4);
  var t5;
  if ($[6] === Symbol["for"]("react.memo_cache_sentinel")) {
    t5 = {
      stringKey: "product.sizeLabel",
      primaryValue: "Size",
      description: "Header text representing 'size' of apparel or shoe."
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  var sizeLabel = useI18nString(t5);
  var t6 = "".concat(crcCode);
  var t7;
  if ($[7] !== crcCode || $[8] !== t6) {
    t7 = {
      stringKey: t6,
      primaryValue: crcCode,
      description: "CRC Code for Error Message"
    };
    $[7] = crcCode;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  var crcSpecificMessage = useI18nString(t7);
  var t8;
  if ($[10] === Symbol["for"]("react.memo_cache_sentinel")) {
    t8 = {
      stringKey: FALLBACK_STRING_KEY,
      primaryValue: FALLBACK_PRIMARY_VALUE,
      description: "Default error message for CRC code"
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  var fallbackMessage = useI18nString(t8);
  var t9;
  if ($[11] !== productQueries) {
    t9 = productQueries.every(_temp4);
    $[11] = productQueries;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  var allQueriesSuccessful = t9;
  var t10;
  if ($[13] !== productQueries) {
    t10 = productQueries.some(_temp5);
    $[13] = productQueries;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  var hasProductData = t10;
  if (productIds !== null && productIds !== void 0 && productIds.length) {
    var _t = itemsRemoved ? removedMessage : unavailableMessage;
    var t12;
    if ($[15] !== _t) {
      t12 = /*#__PURE__*/React.createElement(MessageText, null, _t);
      $[15] = _t;
      $[16] = t12;
    } else {
      t12 = $[16];
    }
    var t13;
    if ($[17] !== allQueriesSuccessful || $[18] !== hasProductData || $[19] !== productQueries || $[20] !== sizeLabel) {
      t13 = allQueriesSuccessful && hasProductData ? productQueries.map(function (query_1, i) {
        var _query_1$data;
        var productData = (_query_1$data = query_1.data) === null || _query_1$data === void 0 ? void 0 : _query_1$data.content;
        return /*#__PURE__*/React.createElement(MessageText, {
          key: i
        }, productData !== null && productData !== void 0 && productData.fullTitle ? "".concat(productData === null || productData === void 0 ? void 0 : productData.fullTitle, ", ") : null, productData !== null && productData !== void 0 && productData.productSize ? sizeLabel : null, " ", productData !== null && productData !== void 0 && productData.productSize ? "".concat(productData === null || productData === void 0 ? void 0 : productData.productSize, ", ") : null, productData !== null && productData !== void 0 && productData.colorDescription ? productData === null || productData === void 0 ? void 0 : productData.colorDescription : null);
      }) : null;
      $[17] = allQueriesSuccessful;
      $[18] = hasProductData;
      $[19] = productQueries;
      $[20] = sizeLabel;
      $[21] = t13;
    } else {
      t13 = $[21];
    }
    var t14;
    if ($[22] !== t12 || $[23] !== t13) {
      t14 = /*#__PURE__*/React.createElement(React.Fragment, null, t12, t13);
      $[22] = t12;
      $[23] = t13;
      $[24] = t14;
    } else {
      t14 = $[24];
    }
    return t14;
  }
  var message = crcSpecificMessage.indexOf("\u226A\u226A") > -1 ? fallbackMessage : crcSpecificMessage;
  var t11;
  if ($[25] !== message) {
    t11 = /*#__PURE__*/React.createElement(MessageText, null, message);
    $[25] = message;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
};
ErrorMessageProductInfo.propTypes = {
  crcCode: PropTypes.string
};
export default ErrorMessageProductInfo;
function _temp(state) {
  return state === null || state === void 0 ? void 0 : state.error;
}
function _temp2(item_0) {
  return item_0 === null || item_0 === void 0 ? void 0 : item_0.productId;
}
function _temp3(productId) {
  return {
    productId: productId,
    fetchVasContent: true
  };
}
function _temp4(query) {
  return query.isSuccess;
}
function _temp5(query_0) {
  var _query_0$data;
  return (_query_0$data = query_0.data) === null || _query_0$data === void 0 ? void 0 : _query_0$data.content;
}